import { createContext } from 'react';

import { TickAxis } from '../../core/utils/formatter-by-ticks.js';

export interface CategoricalBarChartTicks {
  valueAxis: TickAxis;
}

export const CategoricalBarChartTicks = createContext<
  CategoricalBarChartTicks | undefined
>(undefined);

CategoricalBarChartTicks['displayName'] = 'CategoricalBarChartTicks';
